export default __webpack_public_path__ + "static/media/(4).e2e9c7e9.jpg";